import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';

export type OnboardingStepHeadingProps = {
    title: string;
    description: string;
    align?: 'left' | 'center';
};

export function OnboardingStepHeading({
    title,
    description,
    align = 'left',
}: OnboardingStepHeadingProps): ReactElement {
    return (
        <Stack spacing={4} sx={{ textAlign: align, alignItems: align === 'center' ? 'center' : 'stretch' }}>
            <Typography variant="h4" component="h1">
                {title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
                {description}
            </Typography>
        </Stack>
    );
}
